<div class="rtl relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white border-0">
  <div class="rounded-t bg-primary mb-0 px-6 py-6">
    <div class="text-center flex justify-between">
      <h6 class="text-white text-xl font-bold"> ویزیت متنی</h6>

    </div>
  </div>
  <!-- component -->

  <div class="flex max-h-screen-75 antialiased bg-white text-gray-800">
    <div class="flex flex-row max-h-screen-75 w-full">
      
      <div class="flex flex-col flex-auto h-full">
        <div
          class="flex flex-col flex-auto flex-shrink-0 rounded-2xl h-full"
        >
          <div class="flex flex-col h-full overflow-y-auto m-4">
            <div class="flex flex-col h-full min-h-screen-60">
              <div class="grid grid-cols-12 gap-y-2">
                <div *ngFor="let item of this.chatService.userMessageHistory" class="col-start-6 col-end-13 p-3 rounded-lg">
                  <div [ngClass]="item.meIsSender==true?'flex flex-row items-center':'flex items-center justify-start flex-row-reverse'">
                    <div *ngIf="!item.meIsSender"
                      class="flex items-center justify-center h-10 w-10 flex-shrink-0">
                      <img class=" rounded-full" src="../../../../assets/img/default-user-profile.png" alt="">
                    </div>
                    <div 
                    [ngClass]="item.meIsSender==true?'relative ml-3 text-sm bg-primary-light py-2 px-4 shadow rounded':'relative mx-2 text-sm bg-gray-100 py-2 px-4 shadow rounded'">
                      <div *ngIf="item.type==1"> {{item.text}} </div>
                      <div *ngIf="item.type==2"> 
                        <a [href]="apiService.api+item.fileUrl" target="_blank">
                        <img *ngIf="getFileExtension(item.fileUrl)=='png'||getFileExtension(item.fileUrl)=='jpg'||getFileExtension(item.fileUrl)=='jpeg'" class="max-w-180-px h-auto" [src]="apiService.api+item.fileUrl" alt="">  
                        <img *ngIf="getFileExtension(item.fileUrl)!=='png'&&getFileExtension(item.fileUrl)!=='jpg'&&getFileExtension(item.fileUrl)!=='jpeg'" src="../../../../assets/img/icon/file.svg" alt="">
                        <span *ngIf="getFileExtension(item.fileUrl)!=='png'&&getFileExtension(item.fileUrl)!=='jpg'&&getFileExtension(item.fileUrl)!=='jpeg'" class="font-bold px-3"> {{getFileExtension(item.fileUrl)}} </span>
  
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="flex flex-row items-center rounded bg-primary-light w-full p-6">         
            <div class=" w-full ">
              <div class="relative">
                <textarea name="" id="" rows="1" cols="22" [(ngModel)]="msgDto.msgText"
                class="flex w-full border rounded focus:outline-none focus:border-indigo-300 px-8 py-3 pl-10"
                ></textarea>
              </div>
            </div>
  
            <div>
              <label for="file"
                class="flex items-center justify-center bg-transparent rounded-full px-2 py-2 h-10 w-10 relative left-50-px cursor-pointer">
                <img src="../../../../assets/img/icon/paperclip-2.svg" alt="">
              </label>
              <input type="file" id="file" style="visibility: hidden; display:contents"
                            (change)="fileChangeEvent($event);" #file>
            </div>
  
            <div class="ml-4">
              <button (click)="send()"
                class="flex items-center justify-center bg-primary rounded px-2 py-2 h-12 w-12">
                <img class="send-btn w-8" src="../../../../assets/img/icon/send.svg" alt="">
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
  
  <p-toast dir="rtl"></p-toast>
  
  
  <app-modal #modal>
    <!--header-->
    <div class="flex items-start justify-between p-2 border-b border-solid border-blueGray-200 rounded-t">
      <h3 class="text-2xl font-semibold">
        ارسال فایل
      </h3>
      <button
        class="p-1 bg-transparent border-0 text-black opacity-5 float-right text-2xl leading-none font-semibold outline-none focus:outline-none"
        (click)="modal.close()">
        <span class="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
          ×
        </span>
      </button>
    </div>
    <!--body-->
    <div class="relative flex-auto">
      <p class="mt-4 mb-12 text-blueGray-500 text-lg text-start leading-relaxed">
        آیا برای ارسال فایل {{fileName}} اطمینان دارید؟ 
        
      </p>
    </div>
    <!--footer-->
    <div class="flex items-center justify-between py-2 border-solid border-blueGray-200 rounded-b">
      <button
        class="text-red-500 border-red-500 background-transparent font-bold px-6 py-2 rounded text-sm my-2 ease-linear transition-all duration-150"
        type="button" (click)="modal.close();">
        انصراف
      </button>
      <button
        class="bg-primary text-white active:bg-red-500 font-bold text-sm px-6 py-2 rounded shadow hover:shadow-lg my-2 ease-linear transition-all duration-150"
        type="button" (click)="attachFile()">
        تایید
      </button>
    </div>
  </app-modal>







  <!-- <div class="flex max-h-screen-75 antialiased bg-white text-gray-800">
    <div class="flex flex-row max-h-screen-75 w-full">

      <div class="flex flex-col flex-auto h-full p-6">
        <div class="flex flex-col flex-auto flex-shrink-0 rounded-2xl h-full p-4">
          <div class="flex flex-col h-full overflow-y-auto mb-4">
            <div class="flex flex-col h-full min-h-screen-60">
              <div class="grid grid-cols-12 gap-y-2">
                <div *ngFor="let item of this.chatService.userMessageHistory"
                  class="col-start-6 col-end-13 p-3 rounded-lg">
                  <div
                    [ngClass]="item.meIsSender==true?'flex flex-row items-center':'flex items-center justify-start flex-row-reverse'">
                    <div class="flex items-center justify-center h-10 w-10 flex-shrink-0">
                      <img *ngIf="!item.meIsSender" class=" rounded-full"
                        src="../../../../assets/img/default-user-profile.png" alt="">
                    </div>
                    <div
                      [ngClass]="item.meIsSender==true?'relative ml-3 text-sm bg-primary-light py-2 px-4 shadow rounded':'relative mx-2 text-sm bg-gray-100 py-2 px-4 shadow rounded'">
                      <div> {{item.text}} </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex flex-row items-center h-16 rounded bg-white w-full px-4">
            <div class="flex-grow ml-4">
              <div class="relative w-10/12">
                <textarea name="" id="" rows="3" cols="20" [(ngModel)]="msgDto.msgText"
                  class="flex w-full border rounded focus:outline-none focus:border-indigo-300 px-4 m-4 h-16"></textarea>
              </div>
            </div>
            <div class="ml-4">
              <button (click)="send()"
                class="flex items-center justify-center bg-primary rounded text-white px-2 py-1 flex-shrink-0">
                <img class="send-btn w-8" src="../../../../assets/img/icon/send.svg" alt="">
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->